import React, { ComponentProps } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@shadcn/lib/utils';

type LsSpinnerIconProps = ComponentProps<typeof Loader2>;

export const LsSpinnerIcon = (props: LsSpinnerIconProps) => {
  return <Loader2 className={cn('animate-spin')} {...props} />;
};
